"use client";

import { CatalogRecommendedProducts } from "@/features/recommendation";
import { Typography } from "@dafiti/closet-ui";
import { useTranslations } from "next-intl";
import Image from "next/image";

export function CatalogEmptyState() {
  const t = useTranslations("catalog");

  const tips = [
    t("emptyState.tips.typo"),
    t("emptyState.tips.synonym"),
    t("emptyState.tips.general"),
  ];

  return (
    <div
      className="container pt-2 pb-6 lg:pt-4"
      data-testid="catalog-empty-state"
    >
      <div className="flex flex-col-reverse md:flex-row items-center justify-center gap-6 md:gap-10 xl:gap-16 py-6 md:py-10 lg:py-12">
        <div className="flex flex-col items-center text-center md:items-start md:text-start gap-3 lg:gap-4 md:max-w-104.75">
          <div>
            <Typography
              as="h1"
              variant="heading-4"
              className="font-bold lg:text-heading-2 mb-2"
            >
              {t("emptyState.title")}
            </Typography>

            <Typography as="p" variant="body-2" className="lg:text-body-1">
              {t("emptyState.subtitle")}
            </Typography>
          </div>

          <div>
            <Typography as="p" variant="body-3" className="font-bold mb-1">
              {t("emptyState.tipsTitle")}
            </Typography>

            <ul className="list-disc pl-5 text-body-3 text-gray-700 flex flex-col gap-1 text-start">
              {tips.map((tip, index) => (
                <li key={index}>{tip}</li>
              ))}
            </ul>
          </div>
        </div>

        <Image
          className="w-full max-w-71.25 md:max-w-95.25 2xl:max-w-133.5"
          src="https://static.dafiti.com.br/cms/illustrations/catalog-no-results.svg"
          alt={t("emptyState.illustrationAlt")}
          width={535}
          height={320}
          priority
        />
      </div>

      <CatalogRecommendedProducts variant="grid" />
    </div>
  );
}
